module.exports = __webpack_public_path__ + "static/media/responsive-eva.7b36d2aa.png";